import React from "react";
import { Link } from "react-router-dom";

//ASSETS
import Logo from "../assets/nectar-logo.svg";

const navigation = {
  services: [
    { name: "Business Advisory", href: "/business-advisory" },
    { name: "Investment & Acquisition", href: "/investment-acquisition" },
    { name: "Payroll", href: "/payroll" },
    { name: "HR Solutions", href: "/hr-solutions" },
  ],
  company: [{ name: "Contact us", href: "/contact" }],
  social: [
    {
      name: "LinkedIn",
      href: "https://www.linkedin.com/company/nectar-consulting1/about/",
      icon: (props) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path
            id="FontAwsome_linkedin_"
            data-name="FontAwsome (linkedin)"
            d="M22.286,32H1.709A1.722,1.722,0,0,0,0,33.73V54.27A1.722,1.722,0,0,0,1.709,56H22.286A1.726,1.726,0,0,0,24,54.27V33.73A1.726,1.726,0,0,0,22.286,32ZM7.254,52.571H3.7V41.118H7.259V52.571ZM5.475,39.554a2.063,2.063,0,1,1,2.063-2.062A2.063,2.063,0,0,1,5.475,39.554ZM20.587,52.571H17.03V47c0-1.329-.027-3.037-1.848-3.037-1.854,0-2.137,1.446-2.137,2.941v5.668H9.488V41.118H12.9v1.564h.048a3.747,3.747,0,0,1,3.37-1.848c3.6,0,4.27,2.373,4.27,5.459Z"
            transform="translate(0 -32)"
            fill="currentColor"
          />
        </svg>
      ),
    },
    {
      name: "Email",
      href: "mailto:info@nectar1.co.uk",
      icon: (props) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="31.171"
          height="24"
          viewBox="0 0 31.171 24"
          fill="currentColor"
        >
          <path
            id="FontAwsome_envelope_"
            data-name="FontAwsome (envelope)"
            d="M30.58,71.925a.366.366,0,0,1,.591.294V85a2.963,2.963,0,0,1-2.922,3H2.922A2.963,2.963,0,0,1,0,85V72.225a.363.363,0,0,1,.591-.294c1.364,1.088,3.172,2.469,9.382,7.1,1.285.963,3.452,2.988,5.613,2.975,2.173.019,4.383-2.05,5.619-2.975C27.414,74.4,29.216,73.013,30.58,71.925ZM15.585,80c1.412.025,3.446-1.825,4.469-2.588,8.079-6.019,8.694-6.544,10.557-8.044a1.51,1.51,0,0,0,.56-1.181V67a2.963,2.963,0,0,0-2.922-3H2.922A2.963,2.963,0,0,0,0,67v1.188a1.52,1.52,0,0,0,.56,1.181c1.863,1.494,2.478,2.025,10.557,8.044C12.14,78.175,14.173,80.025,15.585,80Z"
            transform="translate(0 -64)"
            fill="currentColor"
          />
        </svg>
      ),
    },
  ],
};

const Footer = () => {
  return (
    <footer className="bg-darkBlue" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 md:py-20 md:px-8">
        <div className="md:grid md:grid-cols-3 md:gap-8">
          <div className="flex flex-row items-center md:mx-auto md:items-start md:flex-col md:space-y-8 md:col-span-1">
            <Link to="/">
              <img className="h-12" src={Logo} alt="Nectar Consulting" />
            </Link>
            <h3 className="hidden text-white md:block">
              Your Business,
              <br />
              <span className="text-earth">Our Passion.</span>
            </h3>
          </div>
          <div className="mt-12 grid grid-cols-2 gap-8 md:mt-0 md:col-span-2">
            <div className="md:mx-auto">
              <h3 className="text-xl font-semibold text-earth tracking-wider">
                Services
              </h3>
              <ul className="mt-4 space-y-2">
                {navigation.services.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.href}
                      className="text-base text-lightGrey hover:text-white"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="md:mx-auto">
              <h3 className="text-xl font-semibold text-earth tracking-wider">
                Company
              </h3>
              <ul className="mt-4 space-y-2">
                {navigation.company.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.href}
                      className="text-base text-lightGrey hover:text-white"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
                <div className="flex space-x-6">
                  {navigation.social.map((item) => (
                    <a
                      key={item.name}
                      href={item.href}
                      target="_blank"
                      rel="noreferrer"
                      className="text-lightGrey hover:text-white"
                    >
                      <span className="sr-only">{item.name}</span>
                      <item.icon className="h-6 w-6" aria-hidden="true" />
                    </a>
                  ))}
                </div>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-12 border-t pt-8" style={{borderColor: "#3A4665"}}>
          <p className="text-base text-lightGrey text-center">
            &copy; 2021 Nectar Consulting. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
